function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 6C12.2761 6 12.5 6.22386 12.5 6.5V17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5V6.5C11.5 6.22386 11.7239 6 12 6Z",
  fill: "#555770"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.15901 8.65901C9.58097 8.23705 10.1533 8 10.75 8H14.5C14.7761 8 15 8.22386 15 8.5C15 8.77614 14.7761 9 14.5 9H10.75C10.4185 9 10.1005 9.1317 9.86612 9.36612C9.6317 9.60054 9.5 9.91848 9.5 10.25C9.5 10.5815 9.6317 10.8995 9.86612 11.1339C10.1005 11.3683 10.4185 11.5 10.75 11.5H13.25C13.8467 11.5 14.419 11.7371 14.841 12.159C15.2629 12.581 15.5 13.1533 15.5 13.75C15.5 14.3467 15.2629 14.919 14.841 15.341C14.419 15.7629 13.8467 16 13.25 16H9C8.72386 16 8.5 15.7761 8.5 15.5C8.5 15.2239 8.72386 15 9 15H13.25C13.5815 15 13.8995 14.8683 14.1339 14.6339C14.3683 14.3995 14.5 14.0815 14.5 13.75C14.5 13.4185 14.3683 13.1005 14.1339 12.8661C13.8995 12.6317 13.5815 12.5 13.25 12.5H10.75C10.1533 12.5 9.58097 12.2629 9.15901 11.841C8.73705 11.419 8.5 10.8467 8.5 10.25C8.5 9.65326 8.73705 9.08097 9.15901 8.65901Z",
  fill: "#555770"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7229 2.01194C14.6776 2.00426 14.631 2.00024 14.5834 2.00024C14.5357 2.00024 14.4891 2.00426 14.4438 2.01194H7.83885C5.21255 2.01194 3 4.04322 3 6.52145V17.4443C3 20.0441 5.09582 22.0002 7.83885 22.0002H16.2709C18.8767 22.0002 21 19.9413 21 17.4443V8.07899C21 7.88403 20.9209 7.69662 20.7794 7.55599L15.4317 2.24406C15.2824 2.09577 15.0762 2.01194 14.8607 2.01194H14.7229ZM13.7917 3.52142L7.83886 3.52222C6.07381 3.52222 4.5834 4.89052 4.5834 6.52152V17.4444C4.5834 19.2027 5.96271 20.49 7.83886 20.49H16.2709C17.9964 20.49 19.4166 19.1128 19.4166 17.4444L19.4161 9.03089L18.491 9.0339C18.139 9.03349 17.7386 9.03278 17.2935 9.03181C15.4248 9.02805 13.9001 7.63181 13.7972 5.87386L13.7917 5.68417V3.52142ZM18.5495 7.52143L17.297 7.5216C16.2347 7.51946 15.375 6.69759 15.375 5.68417V4.36829L18.5495 7.52143Z",
  fill: "#555770"
});

function SvgDollarPaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarPaper);
export default __webpack_public_path__ + "static/media/dollar-paper.97a16aa7.svg";
export { ForwardRef as ReactComponent };